import { Link } from "@inertiajs/react";

import Avatar from "hardcover-ui/components/Avatar";
import Icon from "hardcover-ui/components/Icon";
import Text from "hardcover-ui/components/Text";
import faCommentDots from "icons/solid/comment-dots.svg";
import faStar from "icons/solid/star.svg";
import {
  BookSerializersBookByline,
  PageSerializersBooksLayout,
  UserBookSerializersUserBookByline,
} from "types/serializers";

import LocaleNumber from "../ui/LocaleNumber";

export function UserBookAvatar({
  userBook,
  book,
  showRating = true,
}: {
  userBook: UserBookSerializersUserBookByline;
  book: BookSerializersBookByline;
  showRating?: boolean;
}) {
  let link = `/books/${book.slug}/reviews`;
  if (userBook.user.username) {
    link = userBook.hasReview
      ? `/books/${book.slug}/reviews/@${userBook.user.username}`
      : `/@${userBook.user.username}`;
  }

  return (
    <Link
      href={userBook.user.username ? link : `/books/${book.slug}/reviews`}
      className="relative flex-col text-center py-3 px-2 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-900"
      data-tooltip-id="tooltip"
      data-tooltip-content={
        userBook.user.username ? `@${userBook.user.username}` : ""
      }
    >
      {userBook.hasReview && (
        <Icon
          icon={faCommentDots}
          size="xs"
          className="absolute right-0 top-1 fill-gray-400 dark:fill-gray-300 w-3 h-3"
        />
      )}
      <Avatar
        image={userBook.user.image}
        size="sm"
        alt={`@${userBook.user.username}`}
        isLink
      />
      {showRating && userBook.rating > 0 && (
        <Text variant="secondary" size="sm" className="font-semibold">
          <LocaleNumber number={userBook.rating} />
          <Icon icon={faStar} className="fill-yellow-500" size="sm" />
        </Text>
      )}
    </Link>
  );
}

export default function UserBookAvatars({
  userBooks,
  book,
}: {
  userBooks: UserBookSerializersUserBookByline[];
  book: PageSerializersBooksLayout;
}) {
  return (
    <div className="flex flex-row flex-wrap">
      {userBooks.map(userBook => (
        <UserBookAvatar
          userBook={userBook}
          book={book}
          key={`user-book-avatar-${userBook.userId}-${userBook.bookId}-${userBook.statusId}`}
        />
      ))}
    </div>
  );
}
